import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicScriptLoaderService } from '../../services/dynamic-script-loader.service';
import { OrderService } from '../../services/order.service';
import { Order } from '../../models/Order';
import { Observable } from 'rxjs';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: [
    './home.component.css'
  ]
})
export class HomeComponent implements OnInit {

  currentOrderId: string = '012019';
  maxTotalQuantity: number = 25;
  orderTotalQuantity: number = 0;
  currentOrder: Observable<Order>;

  order: Order = {};

  @ViewChild('orderForm') form: any;

  constructor(private dynamicScriptLoader: DynamicScriptLoaderService, private orderService: OrderService) {
    //this.currentOrder = orderService.getOrder(this.currentOrderId);
    this.orderService.getOrdersById(this.currentOrderId).subscribe(orders => {
      this.orderTotalQuantity = this.maxTotalQuantity;
      this.orderTotalQuantity = this.orderTotalQuantity - orders.length;
    });
  }

  ngOnInit() {
    //this.loadScripts();
  }

  private loadScripts() {
    this.dynamicScriptLoader.load('custom').then(data => {
      // Script Loaded Successfully
    }).catch(error => console.log(error));
  }

  onSubmit({ value, valid }: { value: Order, valid: boolean }) {
    if (!valid) {
      console.log('error u fuck');
    } else {
      value.id = this.currentOrderId;
      value.quantity = 1;
      this.orderService.addOrder(value);
      console.log('added');
    }
  }
}
